import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merge Detail|Other Requirements|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMergeDetailsRequirements';
export type SPCandidateSystemActivityMergeDetailsRequirementsLocNames =
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`;

export const spCandidateSystemActivityMergeDetailsRequirementsLocs: LocDefs<SPCandidateSystemActivityMergeDetailsRequirementsLocNames> =
	{
		SPCandidateSystemActivityMergeDetailsRequirementsLabelType: {
			defaultValue: 'Type',
			description: 'Label for: Type.',
			displayPath: `${pathStart}Type`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ReqTable.ColumnHeading.Type',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsRequirementsLabelName: {
			defaultValue: 'Name',
			description: 'Label for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ReqTable.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsRequirementsLabelActiveDate: {
			defaultValue: 'Active Date',
			description: 'Label for: Active Date.',
			displayPath: `${pathStart}Active Date`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ReqTable.ColumnHeading.ActiveDate',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsRequirementsLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Label for: Expire Date.',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ReqTable.ColumnHeading.ExpireDate',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergeDetailsRequirementsLocType =
	LocMap<SPCandidateSystemActivityMergeDetailsRequirementsLocNames>;
